import { useEffect } from "react";

// Inhalte sind per CSS immer sichtbar. Der Observer markiert Elemente nur
// zusaetzlich als "revealed" - Elemente im Viewport sofort, damit auf
// Mobilgeraeten keine Karte unsichtbar bleiben kann.
export default function useReveal() {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll("[data-reveal]"));
    if (!nodes.length) return undefined;

    // Alles was bereits im Viewport liegt (oder darueber) sofort einblenden
    nodes.forEach((n) => {
      if (n.getBoundingClientRect().top < window.innerHeight) {
        n.classList.add("revealed");
      }
    });

    if (!("IntersectionObserver" in window)) {
      nodes.forEach((n) => n.classList.add("revealed"));
      return undefined;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px" }
    );

    nodes.forEach((n) => {
      if (!n.classList.contains("revealed")) io.observe(n);
    });

    return () => io.disconnect();
  });
}
